import React from 'react';
import FacetContainer from '../customFacet';
import FilterSummary from '../facet/FilterSummary';

const MobileFilterMenu = () => (
    <div className="mobile-filters">
      {/* Filter menu open button */}
      <div className="filter-bar__combined-menu" id="filter-bar__combined-menu">
        <a className="filter-bar__combined-menu__a erase-trace" href="#filter-bar__menu">
          <span className="filter-bar__text-label-mobile job-filter-counter--number">Filters</span>
          <span className="filter-bar__filter-icon"></span>
        </a>
      </div>
      {/* Mobile filter drawer */}
      <div className="filter-bar__menu filter-bar__menu--job" id="filter-bar__menu">
        <div className="filter-bar__header-mobile">
          <a
            className="filter-bar__header-mobile__close-icon erase-trace "
            href="#filter-bar__content"
            aria-label="close"
          ></a>
        </div>
        <FilterSummary className="filter-summary"></FilterSummary>
        <FacetContainer key={'2'} field={'placement_types.enum'} label={'Placement type'} />
        <FacetContainer key={'4'} field={'offsite_pref_filter_option.enum'} label={'Location preference'} />
        <FacetContainer key={'1'} field={'markets.enum'} label={'Location'} />
      </div>
      {/* Mobile footer buttons */}
      <div className="filter-bar__dropdown-buttons-mobile has-core-black-background-color">
        <a className="tertiary-info erase-trace" href={window.aqJobsOptions.relativeListingUrl}>Clear all</a>
        <div className="wp-block-button a-button">
          <button
            className="a-button__link__text default-text"
            onClick={() => window.location.replace('#filter-bar__content')}
          >
            Show Results
          </button>
        </div>
      </div>
    </div>
);
export default MobileFilterMenu;
